import type { IconName } from '@/components/entities/Sprite/Icon';
import type { CategoryListItemDto } from '@/queries/categories/categories.schema';
import { Icon } from '@/components/entities/Sprite/Icon';
import { CATEGORY_ICONS } from '@/consts/CategoryIcons';
import { useSidebarLink } from '@/hooks/useLinkHandler';
import { AppRoutes } from '@/i18n/constants';
import { Link } from '@/i18n/routing';
import { cn } from '@/utils/cn';
import { capitalizeWords } from '@/utils/texts.utils';

const CategoryItem = ({ category, categoryId, handleCloseSideBar, isMenuMinify, className }: {
  category: CategoryListItemDto;
  categoryId: string;
  handleCloseSideBar?: () => void;
  isMenuMinify: boolean;
  className?: string;
}) => {
  const categoryUrl = AppRoutes.categoryIdPaged(category.id);

  const handleClick = useSidebarLink(handleCloseSideBar);
  return (
    <Link
      key={category.id}
      href={categoryUrl}
      onClick={e => handleClick(e, categoryUrl)}
      className={cn('block w-full min-w-0 transition-all duration-150 ease-in-out cursor-pointer md:hover:scale-[1.02]', className)}
      prefetch={false}
    >
      <div className={cn(
        'relative flex w-full min-w-0 items-center gap-2 py-2.5 px-3 md:px-3 rounded-[3.125rem]',
        'text-violet-c100 paragraph-s-medium font-normal',
        'transition-colors duration-200 hover:bg-main-800 hover:text-white',
        categoryId === category.id && 'bg-main-800 text-white',
      )}
      >
        <Icon
          name={CATEGORY_ICONS[category.id] as IconName}
          className={cn('relative size-6 shrink-0', categoryId === category.id && 'text-white')}
        />
        <span
          className={cn(
            'relative overflow-hidden whitespace-nowrap',
            isMenuMinify ? 'opacity-0 max-w-0 ml-[-10px]' : 'opacity-100 max-w-[200px]',
            categoryId === category.id && 'text-white',
          )}
        >
          {capitalizeWords(category.name)}
        </span>
      </div>
    </Link>
  );
};

export default CategoryItem;
